//
import Model from '@/models/Model'
import CustomerAccountModel from '@/models/Sale/SlCustomerAccount'
import SaleDebitNoteModel from '@/models/Sale/SlSaleDebitNote'
import SaleInvoiceService from '@/services/api/Sale/SlSaleInvoice'

/**
 * This class describes a sl customer account receivable.
 * @class SlCustomerAccountReceivable (name)
 */
export default class SlCustomerAccountReceivable extends Model {
  /**
   * Related Fetches
   */
  static fetches = {
    sl_customer_account_id: CustomerAccountModel,
    sl_sale_debit_note_id: SaleDebitNoteModel,
    sl_sale_invoice_id: SaleInvoiceService.toList(),
  }

  /**
   * Includes
   */
  static includes = [
    'sl_customer_account',
    'sl_customer_account.sl_customer',
    'sl_customer_branch_offices',
    'sl_sale_debit_note',
    'sl_sale_invoice',
    'sl_sale_invoice.first_pos_sale.g_seller_user.hr_employee',
  ]

  /**
   * { property_description }
   * @type {<type>}
   */
  get balance() {
    return Number(this.amount) - Number(this.paid_amount)
  }

  /**
   * { property_description }
   * @type {<type>}
   */
  get document_type() {
    return this.is_invoice ? 'Factura' : 'Nota de debito'
  }

  /**
   * { property_description }
   * @type {<type>}
   */
  get first_pos_sale_user_name_case() {
    return this.getProperty(
      'sl_sale_invoice.first_pos_sale.g_seller_user.hr_employee.name_case',
      '-'
    )
  }

  /**
   * { property_description }
   * @type {boolean}
   */
  get is_debit_note() {
    return !!this.sl_sale_debit_note_id
  }

  /**
   * { property_description }
   * @type {boolean}
   */
  get is_invoice() {
    return !!this.sl_sale_invoice_id
  }

  /**
   * { property_description }
   * @type {boolean}
   */
  get is_paid() {
    return this.amount == this.paid_amount
  }

  /**
   * { property_description }
   * @type {<type>}
   */
  get sl_customer_alias_name() {
    return this.getProperty('sl_customer_account.sl_customer.alias_name', '-')
  }

  /**
   * { property_description }
   * @type {<type>}
   */
  get sl_customer_branch_offices_address() {
    return this.getProperty('sl_customer_branch_offices.address', '-')
  }

  /**
   * { property_description }
   * @type {<type>}
   */
  get sl_sale_invoice_number() {
    return this.getProperty('sl_sale_invoice.number', '-')
  }

  /**
   * { property_description }
   * @type {<type>}
   */
  get sl_sale_invoice_status() {
    return this.getProperty('sl_sale_invoice.status', '-')
  }

  /**
   * { function_description }
   * @return {string}  { description_of_the_return_value }
   */
  resource() {
    return 'sl_customer_account_receivable'
  }
}
